import { useState, useEffect } from "react";
import { TextField, Box, Button, Typography } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { userSlice } from "../redux/user/userSlice";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { resetPassword } from "../redux/asyncThunk/userActions";
import NewPasswordForm from "../components/NewPasswordForm";

const { clearMessages } = userSlice;

export default function ResetPage() {
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.data);
  const messages = useSelector((state) => state.user.messages);

  const queryParams = new URLSearchParams(location.search);
  const token = queryParams.get("token");

  useEffect(() => {
    if (user) {
      navigate("/main");
    }
  }, [navigate, user]);

  const [email, setEmail] = useState("");

  const [message, setMessage] = useState({
    type: "",
    message: "",
  });

  useEffect(() => {
    setEmail("");
    setMessage({
      type: "",
      message: "",
    });
    dispatch(clearMessages());
  }, [dispatch, location]);

  useEffect(() => {
    setMessage(...messages);
  }, [messages]);

  const handleResetPasswordButton = () => {
    if (email.length > 3) {
      dispatch(resetPassword({ email }));
    }
  };

  return (
    <div>
      <div className="main_block_login">
        <div className={"reset_form"}>
          {token ? (
            <NewPasswordForm token={token} />
          ) : (
            <Box
              component="form"
              onChange={(event) => setEmail(event.target.value)}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                height: "100%",
                alignItems: "center",
                gap: "10px",
                padding: "10px 0",
              }}
            >
              <Typography
                sx={{ color: "white", fontSize: "18px", fontWeight: "bold" }}
              >
                Восстановить пароль
              </Typography>
              <TextField
                id="email"
                label="Email"
                variant="filled"
                sx={{ bgcolor: "white", width: "80%" }}
                value={email || ""}
              />
              {message?.message ? (
                <Box sx={{ color: "white" }}>{message.message}</Box>
              ) : null}
              <Button
                variant="contained"
                onClick={() => handleResetPasswordButton()}
              >
                Восстановить
              </Button>
              <Box sx={{ display: "flex", gap: "5px", padding: "10px 0" }}>
                <ArrowBackIcon sx={{ color: "white" }} />
                <Link to={"/login"} style={{ textDecoration: "none" }}>
                  <Typography sx={{ color: "white", cursor: "pointer" }}>
                    Назад
                  </Typography>
                </Link>
              </Box>
            </Box>
          )}
        </div>
      </div>
      <div className="footer"></div>
    </div>
  );
}
